import { useThemeMode } from '@synoptic/ui-kit/theme/theme-context.js';
import { Suspense, useEffect } from 'react';
import { ensureIntercomBooted, updateIntercomUser } from '@/intercom';
import { useAppLoader } from './loader';
import { useMe } from './use-me';

export const BootIntercom = () => {
  const { authenticated } = useAppLoader();
  const themeMode = useThemeMode();

  ensureIntercomBooted();

  useEffect(() => {
    updateIntercomUser({
      theme_mode: themeMode,
    });
  }, [themeMode]);

  return authenticated ? (
    <Suspense fallback={null}>
      <UpdateIntercomUser />
    </Suspense>
  ) : null;
};

const UpdateIntercomUser = () => {
  const me = useMe();

  useEffect(() => {
    updateIntercomUser({
      created_at: Math.floor(new Date(me.createdAt).getTime() / 1000),
      email: me.protectedFields?.email,
      name: me.fullName || me.username,
      user_hash: me.protectedFields?.intercomHmac,
      user_id: me.id,
    });
  }, [
    me.createdAt,
    me.fullName,
    me.id,
    me.protectedFields?.email,
    me.protectedFields?.intercomHmac,
    me.username,
  ]);

  return null;
};
